import { TransactiondetailsPage } from './pages/transactiondetails/transactiondetails.page';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { HomePage } from './pages/home/home.page';
import { ForgetpasswordPage } from './pages/forgetpassword/forgetpassword.page';
import { AdministrationPage } from './pages/administration/administration.page';
import { MapComponent } from './pages/map/map.page';
import { CartPage } from './pages/cart/cart.page';
import { CartdetailsPage } from './pages/cartdetails/cartdetails.page';
import { PointofsalePage } from './pages/pointofsale/pointofsale.page';
import { PointofsaledetailsPage } from './pages/pointofsaledetails/pointofsaledetails.page';
import { TransactionPage } from './pages/transaction/transaction.page';
import { UserPage } from './pages/user/user.page';
import { ClientPage } from './pages/client/client.page';
import { Role } from './enum/role';
import { ClientEditPage } from './pages/client/modal/clientedit/clientedit.page';
import { UserEditPage } from './pages/user/useredit/useredit.page';
import { ReseauPage } from './pages/reseau/reseau.page';
import { environment } from '../environments/environment';
import { TestPage } from './pages/test/test.page';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'home',
    component: HomePage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'administration',
    component: AdministrationPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] }
  },
  {
    path: 'reset-password',
    component: ForgetpasswordPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'point-of-sale',
    component: PointofsalePage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'point-of-sale/:id',
    component: PointofsaledetailsPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'transaction',
    component: TransactionPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'transaction/:id',
    component: TransactiondetailsPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'cart',
    component: CartPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'cart/:id',
    component: CartdetailsPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'admin/user',
    component: UserPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin/newuser',
    component: UserEditPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin/edituser',
    component: UserEditPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin/client',
    component: ClientPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin/editclient',
    component: ClientEditPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin/newclient',
    component: ClientEditPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'admin/client/:id',
    component: ClientPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'forget-password',
    component: ForgetpasswordPage,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'map',
    component: MapComponent,
    canActivate: [AuthGuard],
    data: { roles: [ Role.Admin, Role.User, Role.AdminBPS] }
  },
  {
    path: 'reseau',
    component: ReseauPage
  },
  {
    path: 'test',
    component: TestPage
  },
  {
    path: '**',
    redirectTo: 'home',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: environment.enableTracing, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})

export class AppRoutingModule { };
